module.exports = __webpack_public_path__ + "img/byssyxx.03620fe7.png";